export default "__VITE_ASSET__Cv2BfSOB__"